/* eslint-disable no-redeclare */
// $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};

export default isInteger;



//////////////////
// WEBPACK FOOTER
// ./~/graphql/polyfills/isInteger.mjs
// module id = TTR6
// module chunks = 9